import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ref',
    templateUrl: './referentiel.component.html',
    styleUrls: ['./referentiel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReferentielComponent implements OnInit {

  @Input() referentiel: string;
  @Input() key: string;

  constructor() { }

  ngOnInit() {
  }

}
